<template>
  <div class="error-container">
    <place-header />
    <div class="content">
      <div class="alert-block">
        <div class="big-title">404 Not Found</div>
        <div class="title2_5">指定したURLは見つかりませんでした。</div>
        <div class="title2_5"><a href="/places">TOP</a>に移動してください。</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import PlaceHeader from "@/components/place/place-header.vue";

export default Vue.extend({
  name: "error-view",
  components: {
    PlaceHeader,
  },
});
</script>

<style lang="scss" scoped>
@import "~@vacancorp/vacan-scss/mixins/media-query.scss";
@import "@/assets/vacan-global.scss";

.error-container {
  height: 100vh;
  .content {
    height: 100vh;
    padding-top: $header-height;
    background-image: url("~@/assets/images/404_bg.svg");
    background-size: 100% auto;
    background-position: center center;
    @include media-query(xs) {
      padding-top: $header-height-short;
    }
    @include media-query(sm) {
      padding-top: $header-height-short;
    }
    .alert-block {
      padding-top: $header-height;
      width: 294px;
      height: 150px;
      margin-left: auto;
      margin-right: auto;
      div {
        text-align: center;
        margin-bottom: 16px;
      }
    }
  }
}
</style>
